var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4KontaktdatenActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_4-kontaktdaten-active",
    "data-name": "4-kontaktdaten-active",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84.562,
    height: 84.562,
    viewBox: "0 0 84.562 84.562",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1979",
    "data-name": "Rechteck 1979",
    width: 84.562,
    height: 84.562,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_688",
    "data-name": "Gruppe 688",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4167",
    "data-name": "Pfad 4167",
    d: "M83.788,42.281A41.507,41.507,0,1,1,42.281.774,41.507,41.507,0,0,1,83.788,42.281",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4168",
    "data-name": "Pfad 4168",
    d: "M42.281,84.562A42.281,42.281,0,1,1,84.562,42.281,42.281,42.281,0,0,1,42.281,84.562m0-83.013A40.732,40.732,0,1,0,83.013,42.281,40.732,40.732,0,0,0,42.281,1.549",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4169",
    "data-name": "Pfad 4169",
    d: "M23.294,37.28",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4170",
    "data-name": "Pfad 4170",
    d: "M28.844,40.533",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4173",
    "data-name": "Pfad 4173",
    d: "M42.266,63.005H25.316a3.473,3.473,0,0,1-3.74-3.738q0-10.783,0-21.569a3.56,3.56,0,0,1,1.907-3.328c1.1-.628,2.178-1.285,3.277-1.908a.6.6,0,0,0,.348-.605c-.012-2.66-.008-5.32-.006-7.98a3.456,3.456,0,0,1,3.679-3.667H53.766a3.463,3.463,0,0,1,3.7,3.693c0,2.631,0,5.263-.007,7.894a.653.653,0,0,0,.372.677c1.091.609,2.156,1.264,3.24,1.885a3.593,3.593,0,0,1,1.921,3.366q-.016,10.763,0,21.526a3.475,3.475,0,0,1-3.767,3.754H42.266M22.972,38.681c-.008.148-.015.219-.015.291q0,10.266,0,20.532a2.066,2.066,0,0,0,2.218,2.12h34.2A2.075,2.075,0,0,0,61.6,59.38q0-10.137,0-20.274c0-.12-.014-.241-.024-.408-.2.111-.345.192-.491.278q-8.437,4.945-16.874,9.894a3.545,3.545,0,0,1-3.867,0q-7.482-4.4-14.977-8.786c-.778-.456-1.557-.91-2.4-1.4M42.282,21.59H30.768a2.091,2.091,0,0,0-2.29,2.308q0,7.98-.008,15.96a.665.665,0,0,0,.379.675q6.049,3.525,12.078,7.084a2.415,2.415,0,0,0,2.7.005q6.042-3.579,12.114-7.107a.6.6,0,0,0,.344-.609q-.013-8-.007-16a2.1,2.1,0,0,0-2.328-2.314H42.282M57.463,33.842V39.5l3.443-2.019c.744-.437.782-.649.224-1.32a1.568,1.568,0,0,0-.374-.354c-1.065-.644-2.138-1.277-3.293-1.964m-30.393.012c-1.15.691-2.265,1.332-3.343,2.031a2.576,2.576,0,0,0-.61.811c-.16.248-.1.428.182.584.9.505,1.786,1.038,2.678,1.559.353.206.709.41,1.12.647,0-1.835,0-3.6,0-5.359,0-.066-.012-.132-.026-.273",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4174",
    "data-name": "Pfad 4174",
    d: "M45.386,36.774a4.151,4.151,0,1,1-.368-5.911,3.78,3.78,0,0,1,.032-.38.668.668,0,0,1,.675-.6.661.661,0,0,1,.687.636c.024.372.009.747.009,1.121,0,1.207,0,2.415,0,3.623a1.387,1.387,0,1,0,2.762-.012,9.449,9.449,0,0,0-.534-3.9A6.952,6.952,0,0,0,41.6,27.143a6.864,6.864,0,0,0-6.14,5.941,6.9,6.9,0,0,0,10.561,6.725c.086-.052.168-.112.256-.159a.685.685,0,1,1,.74,1.154,7.711,7.711,0,0,1-3.02,1.311A8.28,8.28,0,1,1,50.43,32.66a13.7,13.7,0,0,1,.1,3.051,2.657,2.657,0,0,1-1.993,2.346,2.753,2.753,0,0,1-2.923-.988c-.069-.089-.137-.179-.226-.3m-5.865-2.823a2.76,2.76,0,1,0,2.832-2.7,2.766,2.766,0,0,0-2.832,2.7",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4KontaktdatenActive);
export default __webpack_public_path__ + "static/media/4-kontaktdaten-active.249a95d47350415b70b1de4b49147e0d.svg";
export { ForwardRef as ReactComponent };